// Sentry initialization (must be first)
import './sentry-init'

// Dependencies
import { _ } from './utils'
import { globalPageViewTracking, loginTracking, registrationTracking, makeGtmCall } from './tracking'
import Accordion from './modules/accordion'
import Autosuggestion from './modules/autosuggestion'
import burger from './modules/burger'
import CheckboxToggle from './modules/checkbox-toggle'
import ClearInput from './modules/clear-input'
import CloseMessage from './modules/close-message'
import CloseWindow from './modules/close-window'
import FormPost from './modules/form-post'
import ImageTextVideo from './modules/image-text-video'
import LazyLoad from './modules/lazy-load'
import Modal from './modules/modal'
import RevealButton from './modules/reveal-button'
import Sticky from './modules/sticky'
import TinySlider from './modules/tiny-slider'
import toggleClass from './modules/toggle-class'
import objectFit from './modules/object-fit'
// doc events
import Menu from './modules/menu'
import SiteSearch from './modules/site-search'

import BloomreachEngagementRecommenders from "@/javascript/modules/bloomreach-engagement-recommenders";
import LanguageSwitcher from "@/javascript/modules/language-switcher";

window.dataLayer = window.dataLayer || []

const siteSearchEl = _('site-search', 'element').node()

if (siteSearchEl) {
    new SiteSearch(siteSearchEl)
}

new Menu()
new CloseWindow()
globalPageViewTracking()

_('accordion', 'element')
    .nodes()
    .forEach((el) => new Accordion(el))
_('burger')
    .nodes()
    .forEach((el) => burger(el))
_('checkbox-toggle', 'element')
    .nodes()
    .forEach((el) => new CheckboxToggle(el))
_('form-post')
    .nodes()
    .forEach((el) => new FormPost(el))
_('message', 'element')
    .nodes()
    .forEach((el) => new CloseMessage(el))
_('modal')
    .nodes()
    .forEach((el) => new Modal(el))
_('object-fit-contain', 'polyfill')
    .nodes()
    .forEach((el) => objectFit(el, 'contain'))
_('object-fit-cover', 'polyfill')
    .nodes()
    .forEach((el) => objectFit(el, 'cover'))
_('reveal-button')
    .nodes()
    .forEach((el) => new RevealButton(el))
_('sticky')
    .nodes()
    .forEach((el) => new Sticky(el))
_('sticky', 'polyfill')
    .nodes()
    .forEach((el) => new Sticky(el))
_('autosuggestion')
    .nodes()
    .forEach((el) => new Autosuggestion(el))
_('gtm-call')
    .nodes()
    .forEach((el) => makeGtmCall(el))
_('image', 'lazyload')
    .nodes()
    .map((el) => new LazyLoad(el))
_('image-text-video')
    .nodes()
    .forEach((el) => new ImageTextVideo(el))
_('tiny-slider')
    .nodes()
    .forEach((el) => new TinySlider(el))
_('input-clear-trigger')
    .nodes()
    .forEach((el) => new ClearInput(el))
_('toggle-class')
    .nodes()
    .forEach((el) => toggleClass(el))
_('user-login', 'event')
    .nodes()
    .forEach((el) => loginTracking(el))
_('user-reg', 'event')
    .nodes()
    .forEach((el) => registrationTracking(el))

new BloomreachEngagementRecommenders();

new LanguageSwitcher()
